import { useRef, useState } from "react";
import { animated, useSpring } from "@react-spring/web";
import classNames from "classnames";
import { createSearchParams, useNavigate } from "react-router-dom";
import useTranslate from "hooks/useTranslate";
import useClickOutside from "hooks/useClickOutside";
import { useBreakpoint } from "hooks/useBreakpoint";
import ArrowDown from "assets/icons/arrowDown.svg?react";
import SortIcon from "assets/icons/sort.svg?react";
import Checkbox from "../../atoms/Checkbox";
import { GET_PARAMS, GET_POPUP_TYPES } from "../../../constants/popupConfig";
import { TRANSACTION_SORT } from "../../../constants/transactions";
import { TransactionSortType } from "../../../types/Transaction";

import "./styles.sass";

type InviteSortDesktopProps = {
  selected: TransactionSortType;
  onSelect: (option: TransactionSortType) => void;
};

const InviteSortDesktop = (props: InviteSortDesktopProps) => {
  const { selected, onSelect } = props;
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoint();
  const [isOpen, setIsOpen] = useState(false);
  const projectName = import.meta.env.VITE_APP_PROJECT_NAME;
  const isBanger = projectName === "banger";
  const sortRef = useRef(null);

  const [spring, api] = useSpring(() => ({
    height: 0,
  }));

  const t = useTranslate();

  const open = () => {
    api.start({ height: 144 });
    setIsOpen(true);
  };
  const close = () => {
    api.start({ height: 0 });
    setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  useClickOutside({ refs: [sortRef], handler: close });

  const handleClick = () => {
    if (isOpen) {
      close();
    } else if (!isDesktop) {
      navigate({
        search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.sortTransaction })}`,
      });
    } else {
      open();
    }
  };

  const handleSelect = (option: TransactionSortType) => {
    close();
    onSelect(option);
  };

  const btnClass = classNames("InviteSortDesktop__btn", { active: isOpen });

  return (
    <div className="InviteSortDesktop" ref={sortRef}>
      <span className="InviteSortDesktop__sort">{t("transactions.show")}:</span>
      {/* eslint-disable-next-line react/button-has-type */}
      <button className={btnClass} onClick={handleClick}>
        <span className="InviteSortDesktop__title">{t(selected.title)}</span>
        <div className="InviteSortDesktop__arrow">
          {isDesktop ? (
            <ArrowDown />
          ) : (
            <SortIcon className={isBanger ? "InviteSortDesktop__icon" : ""} />
          )}
        </div>
      </button>
      {isOpen && (
        <animated.div
          className="InviteSortDesktop__content"
          style={{ ...spring }}
        >
          {TRANSACTION_SORT.map((sort) => {
            const itemClass = classNames("InviteSortDesktop__item", {
              active: selected.id === sort.id,
            });
            return (
              <div
                key={sort.id}
                className={itemClass}
                onClick={() => handleSelect(sort)}
              >
                {t(sort.title)}
                {selected.id === sort.id && (
                  <Checkbox
                    name={sort.title}
                    borderNone
                    mode="dark"
                    checked={selected.id === sort.id}
                  />
                )}
              </div>
            );
          })}
        </animated.div>
      )}
    </div>
  );
};

export default InviteSortDesktop;
